module.exports = __webpack_public_path__ + "static/media/c542025d-8163-47cd-835a-3d764ec5ecde_1.d52c2522977d35295712952645836e33.daee9d9d.jpeg";